import React from 'react';

import {RelatedEntitiesWidgetProps} from "../models/related-entities-widget.props";
import {RelatedEntitiesWidgetController} from "../related-entities-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {Loader} from "../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";
import classNames from "classnames";
import styles from "../styles/related-entities-widget.module.scss";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {RelatedEntitiesWidgetContent} from "./related-entities-widget.content";

export const RelatedEntitiesWidgetComponent = ({controller}: RelatedEntitiesWidgetProps) => {
  const {state, device: {isSmallView}} = controller;
  const {fetchingState, componentState, title} = state;

  const entitiesProps = {
    controller,
  }

  const loaderProps = {
    className: classNames(styles.placeholder),
    when: fetchingState === FETCHING_STATES.fetching || componentState === COMPONENT_STATES.loading
  }

  const wrapperProps = {
    className: classNames(styles.container, {[styles.small_view]: isSmallView}),
    controller,
    title
  }

  return (
    <WidgetWrapper {...wrapperProps}>
      <Loader {...loaderProps}>
        <RelatedEntitiesWidgetContent {...entitiesProps}/>
      </Loader>
    </WidgetWrapper>
  )
}

const settings: ComposeSettings = {
  component: RelatedEntitiesWidgetComponent,
  propsType: RelatedEntitiesWidgetProps,
  controllerType: RelatedEntitiesWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,

  observe: true,
};

export default Compose(settings);